// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Exclamation: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M29.7 15c0-3.9-1.5-7.6-4.3-10.4S18.9.3 15 .3 7.4 1.8 4.6 4.6.3 11.1.3 15s1.5 7.6 4.3 10.4 6.5 4.3 10.4 4.3 7.6-1.5 10.4-4.3l-.7-.7.7.7c2.8-2.8 4.3-6.5 4.3-10.4zm-2 0c0 3.4-1.3 6.6-3.7 9s-5.6 3.7-9 3.7-6.6-1.3-9-3.7-3.7-5.6-3.7-9S3.6 8.4 6 6s5.6-3.7 9-3.7 6.6 1.3 9 3.7 3.7 5.6 3.7 9z"/><path d="M14 17V9c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1s-1-.4-1-1zm0 4c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1z"/></svg>;
};

export default React.memo(Exclamation);
